module.exports = __webpack_public_path__ + "72607b0a9da7a202fba01a98907b6d9c.jpg";